import './QuestionGrid.sass';

import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import _ from 'underscore';

import DropDown from '../../../../commonComponents/DropDown/DropDown';
import EditQuestionModal from '../../../../commonComponents/Modals/EditQuestionModal/EditQuestionModal';
import Spinner from '../../../../commonComponents/Spinner/Spinner';
import {
  getChapterValidationReport,
  getValidationSummary,
} from '../../../../utilities/questionValidation';
import * as api from '../../../../utilities/ServiceManager';
import QuestionBirectionalList from '../../commonComponents/QuestionBirectionalList/QuestionBirectionalList';
import Pagination from './Pagination';
import QuestionGridRow, {
  QUESTION_ID_TOOLTIP_ID,
  VALIDATION_ISSUES_TOOLTIP_ID,
} from './QuestionGridRow';

export default class QuestionGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      questionsPerPage: 100,
      spellCheckCells: false,
      sort: { by: 'presentationIndex', ascending: true },
      // null until Run validation has been pressed; afterwards a map of
      // question id -> issue messages, replaced in full on every run.
      validationIssues: null,
      isValidating: false,
    };
  }

  componentDidMount() {
    this.props.getSpellCheckWhitelistWords();
    this.props.getCommonAiAdminFeedbackTemplates();
    this.props.setIsCreatingAiQuestion(false);
    this.props.amountOfQuestionsInChapter(
      this.props.chapter.id,
      this.props.assignment ? this.props.assignment.id : null,
    );
    this.props.onClearQuestions();
    this.props.loadQuestionsOfChapter(
      this.props.chapter.id,
      0,
      this.state.questionsPerPage === 'ALL' ? 0 : this.state.questionsPerPage,
      this.props.assignment ? this.props.assignment.id : null,
      false,
      0,
      this.props.isShowDeletedQuestions,
      false, // loadAll
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isCreatingAiQuestion !== this.props.isCreatingAiQuestion) {
      this.props.setIsCreatingAiQuestion(false);
    }
  }

  getOptions() {
    const style = {
      textAlign: 'center',
    };

    return [
      {
        name: 'Sort by Soft Page \nascending',
        event: () => {
          this.setState({ sort: { by: 'softwarePage', ascending: true } });
        },
        style,
      },
      {
        name: 'Sort by Soft Page \ndescending',
        event: () => {
          this.setState({ sort: { by: 'softwarePage', ascending: false } });
        },
        style,
      },
      {
        name: 'Sort by Index \nascending',
        event: () => {
          this.setState({
            sort: { by: 'presentationIndex', ascending: true },
          });
        },
        style,
      },
      {
        name: 'Sort by Index \ndescending',
        event: () => {
          this.setState({
            sort: { by: 'presentationIndex', ascending: false },
          });
        },
        style,
      },
    ];
  }

  getDefaultQuestion() {
    return {
      notes: '',
      softwarePage: null,
      documentPage: null,
      text: '',
      answers: [
        { correct: true, order: 0, text: '', id: 1 },
        { correct: false, order: 0, text: '', id: 2 },
        { correct: false, order: 0, text: '', id: 3 },
        { correct: false, order: 0, text: '', id: 4 },
      ],
      multipleOptionMode: true,
      defaultQuestion: true,
    };
  }

  createQuestion = (newQuestion) => {
    newQuestion.flashQuestionText = newQuestion.text;
    if (typeof newQuestion.customPromptId === 'string') {
      newQuestion.customPromptId = this.props.userCustomPrompts[0].id;
    }
    newQuestion.creationView = 'grid';

    this.props.onCreateQuestion(
      newQuestion,
      this.props.assignment ? this.props.assignment.id : null,
    );
  };

  createQuestionModal = (newQuestion) => {
    this.props.openModal({
      modalClassName: 'modal-edit-question',
      modalContent: (
        <EditQuestionModal
          question={newQuestion}
          closeModal={this.props.closeModal}
          item={newQuestion}
          title="Question"
          textarea
          onSubmit={this.createQuestion}
          isQuestion
          isPresentationIndex={false}
          assignment={this.props.assignment ? this.props.assignment.id : null}
          multipleOption
          showWarning={this.props.showWarning}
          setIsCreatingAiQuestion={this.props.setIsCreatingAiQuestion}
          isCreatingAiQuestion={this.props.isCreatingAiQuestion}
          userCustomPrompts={this.props.userCustomPrompts}
          createUserCustomPrompt={this.props.createUserCustomPrompt}
          chapterId={this.props.chapter.id}
          improveQuestionWithAi={this.props.improveQuestionWithAi}
          selectedQuestion={this.props.selectedQuestion}
          isSaveQuestion={this.props.isSaveQuestion}
          updateIncludeNotesInSuggestion={
            this.props.updateIncludeNotesInSuggestion
          }
          spellCheckEnabled={this.state.spellCheckCells}
        />
      ),
    });
  };

  renderHeader() {
    const newQuestion = this.getDefaultQuestion();
    newQuestion.chapter = this.props.chapter.id;
    delete newQuestion.softwarePage;
    delete newQuestion.documentPage;
    return (
      <div className="headerContainer">
        <div style={{ width: '3%' }} className="tHeader">
          {this.props.editPermission && (
            <i
              onClick={() => this.createQuestionModal(newQuestion)}
              className="fa fa-plus fa-lg mt-1"
            />
          )}
        </div>
        <div style={{ width: '16%' }} className="tHeader">
          QUESTION
        </div>
        <div style={{ width: '12%' }} className="tHeader">
          OPTION A (CORRECT)
        </div>
        <div style={{ width: '12%' }} className="tHeader">
          OPTION B
        </div>
        <div style={{ width: '12%' }} className="tHeader">
          OPTION C
        </div>
        <div style={{ width: '12%' }} className="tHeader">
          OPTION D
        </div>
        <div style={{ width: '3%' }} className="tHeader">
          Soft Page
        </div>
        <div style={{ width: '3%' }} className="tHeader">
          Doc Page
        </div>
        <div style={{ width: '16%' }} className="tHeader">
          FURTHER READING
        </div>
        <div style={{ width: '10%' }} className="tHeader">
          ADMIN FEEDBACK
        </div>
        <div
          style={{
            width: '1.5%',
            overflow: 'visible',
            display: 'flex',
            justifyContent: 'center',
            padding: 0,
          }}
          className="tHeader"
        >
          <DropDown
            style={{
              top: '-20px',
              position: 'absolute',
              left: '-160px',
              zIndex: 10000,
            }}
            title=""
            options={this.getOptions()}
          />
        </div>
      </div>
    );
  }

  renderRows(questions) {
    return _.sortBy(questions, 'presentationIndex').map((question, index) => (
      <QuestionGridRow
        key={index}
        question={question}
        amountOfQuestions={questions.length}
        {...this.props}
        spellCheckCells={this.state.spellCheckCells}
        validationIssues={this.state.validationIssues}
      />
    ));
  }

  rederRowsSortBy(questions) {
    let option = 'presentationIndex';
    const direction = this.state?.sort?.ascending ? 'asc' : 'desc';
    const orderBy = this.state?.sort?.by;
    if (orderBy) {
      switch (orderBy) {
        case 'softwarePage':
          option = 'softwarePage';
          break;
        default:
          option = 'presentationIndex';
      }
    }

    const questionSort =
      direction === 'asc'
        ? _.sortBy(questions, option)
        : _.sortBy(questions, option).reverse();

    return questionSort.map((question, index) => (
      <QuestionGridRow
        key={index}
        question={question}
        amountOfQuestions={questions.length}
        {...this.props}
        spellCheckCells={this.state.spellCheckCells}
        validationIssues={this.state.validationIssues}
      />
    ));
  }

  questionsPerPage = (amount) => {
    this.setState({ questionsPerPage: amount });
  };

  spellCheckCellsOnChange = () => {
    this.setState({ spellCheckCells: !this.state.spellCheckCells });
  };

  runValidation = async () => {
    if (this.state.isValidating) {
      return;
    }

    this.setState({ isValidating: true });

    try {
      // The whole chapter is checked, not only the questions on screen, so the
      // result always agrees with what happens when the assignment is
      // submitted. loadAll bypasses the page size: a chapter with more
      // questions than one page holds must not come back as "No issues found"
      // on the strength of its first page alone.
      const response = await api.getQuestionsOfChapter(
        this.props.chapter.id,
        0,
        null,
        this.props.assignment ? this.props.assignment.id : null,
        0,
        false,
        true,
        null,
      );

      const validationIssues = {};
      getChapterValidationReport(response.data).forEach((entry) => {
        validationIssues[entry.questionId] = entry.reasons;
      });

      this.setState({ validationIssues });
    } catch (exception) {
      this.props.showWarning(
        'Run validation',
        'Could not validate the chapter questions. Please try again later.',
      );
    } finally {
      this.setState({ isValidating: false });
    }
  };

  renderValidationSummary() {
    const { validationIssues } = this.state;

    if (!validationIssues) {
      return null;
    }

    const questionCount = Object.keys(validationIssues).length;

    if (questionCount === 0) {
      return <span className="validationSummary">No issues found</span>;
    }

    const issueCount = Object.values(validationIssues).reduce(
      (total, reasons) => total + reasons.length,
      0,
    );

    return (
      <span className="validationSummary">
        {getValidationSummary(issueCount, questionCount)}
      </span>
    );
  }

  render() {
    const { questions } = this.props;
    return (
      <div className="questionGridContainer">
        <ReactTooltip
          id={VALIDATION_ISSUES_TOOLTIP_ID}
          place="right"
          variant="dark"
          className="react-tooltip gridTooltip validationIssuesTooltip"
        />
        <ReactTooltip
          id={QUESTION_ID_TOOLTIP_ID}
          place="right"
          variant="dark"
          className="react-tooltip gridTooltip"
        />
        <div className="gridActionsContainer">
          <Pagination
            assignment={this.props.assignment?.id ?? null}
            chapter={this.props.params?.chapter ?? this.props.chapter?.id}
            isShowDeletedQuestions={this.props.isShowDeletedQuestions}
            loadQuestionsOfChapter={this.props.loadQuestionsOfChapter}
            questionsPerPages={this.state.questionsPerPage}
            amountOfQuestions={parseInt(this.props.amountOfQuestions)}
            questionsPerPage={this.questionsPerPage}
            onClearQuestions={this.props.onClearQuestions}
            amountOfQuestionsInChapter={this.props.amountOfQuestionsInChapter}
          />
          <div className="gridActionsGroup">
            {/* The summary sits before the button so that showing it does not
                push the button along the row. */}
            {this.renderValidationSummary()}
            <button
              type="button"
              className="btn btn-info runValidationButton"
              onClick={this.runValidation}
              disabled={this.state.isValidating}
            >
              {this.state.isValidating ? 'Validating...' : 'Run validation'}
            </button>
            <div className="spellCheckSwitch">
              Spell check cells{' '}
              <input
                type="checkbox"
                checked={this.state.spellCheckCells}
                value={this.state.spellCheckCells}
                onChange={this.spellCheckCellsOnChange}
              />
            </div>
          </div>
        </div>

        {this.state.questionsPerPage === 'ALL' ? (
          <>
            {this.props.isUpdating && <Spinner />}
            <QuestionBirectionalList>
              <div className="questionGridContainerScroll">
                {this.renderHeader()}
                {this.state?.sort.by
                  ? this.rederRowsSortBy(questions)
                  : this.renderRows(questions)}
              </div>
            </QuestionBirectionalList>
          </>
        ) : (
          <>
            {(this.props.isLoadingQuestions || this.props.isUpdating) && (
              <Spinner />
            )}
            <div className="questionGridContainerScroll">
              {this.renderHeader()}
              {this.state?.sort.by
                ? this.rederRowsSortBy(questions)
                : this.renderRows(questions)}
            </div>
          </>
        )}
      </div>
    );
  }
}
